module.exports = __webpack_public_path__ + "static/media/contraction0_img.995e4137.JPG";